import React from 'react';
import { UploadOutlined } from '@ant-design/icons';
import useFormField from '@hooks/useFormField';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Button, Form, Upload } from 'antd';

const FileUploadField = (props) => {
    const { label, fileList, disabled, fieldName, accept, onChange, beforeUpload, style } = props;

    const uploadFile = ({ file, onSuccess }) => {
        const { uploadFile } = props;
        if (uploadFile) {
            uploadFile(file, onSuccess);
        } else {
            setTimeout(() => {
                onSuccess('ok');
            }, 0);
        }
    };

    const { rules } = useFormField(props);
    const translate = useTranslate();

    return (
        <Form.Item label={label} name={fieldName} rules={rules} valuePropName={fieldName} style={style}>
            <Upload
                fileList={fileList}
                disabled={disabled}
                accept={accept}
                customRequest={uploadFile}
                beforeUpload={beforeUpload}
                onChange={onChange}
                showUploadList={true}
                maxCount={1}
            >
                <Button loading={props.loading}>
                    <UploadOutlined /> {translate.formatMessage(commonMessage.clickUpload)}
                </Button>
            </Upload>
        </Form.Item>
    );
};

export default FileUploadField;
